// extracted by mini-css-extract-plugin
export default {"pageContainer":"PageContainer_pageContainer__5p1b9"};